import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { PtrService } from '../ptr-service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { encryptionService } from 'src/app/common-service/cedService';
import { ToastrService } from 'ngx-toastr';
import { HelperService } from 'src/app/common-service/helper.service';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { UsrmgtService } from 'src/app/usermgt/services/usrmgt.service';
import { EncrDecrService } from 'src/app/common-service/EncrDecrService';
import { SignupService } from 'src/app/common-service/signup.service';

@Component({
  selector: 'app-view-details',
  templateUrl: './view-details.component.html',
  styleUrls: ['./view-details.component.css']
})
export class ViewDetailsComponent implements OnInit {
  filepath: any = '/opt/ptrRegistartionFiles/';
  submitted = false;
  redirectPageCounter = 10;
  userDetails: any;
  getRegDraftDetails: any;
  registrationId: any;
  maxDate: string;
  inviteemaxDate: string;
  PermittedMaxDate: string;
  public form: FormGroup;
  toAddressArr: any = [];
  decryptRegistrationId: any;
  i: any = 0;
  today1 = moment().format('YYYY-MM-DD');
  inviteeFileName: any = [];
  subscribe: Subject<any> = new Subject<any>();
  countryList: any = [];
  stateList: any = [];
  cityList: any = [];
  allstateList: any = [];
  allcityList: any = [];
  roleName: any = [];
  seekClarificationForm: FormGroup;
  @ViewChild('seekClarificationCandidateDismissModal') seekClarificationCandidateCloseBtn: ElementRef<HTMLElement>;

  constructor(public tostar: ToastrService, public router: Router, private formBuilder: FormBuilder, public route: ActivatedRoute,
    public helper: HelperService, public ptrService: PtrService, private spinner: NgxSpinnerService,
    public ced: encryptionService, private toastr: ToastrService, public serverURL: ServerURLService,
    private _form: FormBuilder, public usrMgtService: UsrmgtService, public EncrDecr: EncrDecrService, public signinService: SignupService) { }
  formGroupId = this.formBuilder.group({
    name: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]],
    userEmail: ['', [Validators.required, Validators.email, Validators.maxLength(255)]],
    addressLine1: ['', [Validators.required, Validators.maxLength(255)]],
    addressLine2: ['', [Validators.required, Validators.maxLength(255)]],
    countryId: ['', Validators.required],
    stateId: ['', Validators.required],
    cityId: ['', Validators.required],
    pinCode: ['', [Validators.required, Validators.maxLength(10), Validators.pattern("^[0-9]*$")]],
    mobileNumber: ['', [Validators.required, Validators.maxLength(10), Validators.pattern("^[0-9]*$")]],
    landlineNumber: ['', [Validators.required, Validators.maxLength(20), Validators.pattern("^[0-9]*$")]],
    certificateRegistration: ['', [Validators.required, Validators.maxLength(100)]],
    purposeConducting: ['', [Validators.required, Validators.maxLength(100)]],
    startDate: ['', Validators.required],
    endDate: ['', Validators.required],
    permittedStartDate: ['', Validators.required],
    permittedEndDate: ['', Validators.required],
    venueProgram: ['', Validators.required],
    completeBio: ['', Validators.required],
    documentaryProof: ['', Validators.required],
    validityRegistration: ['', Validators.required],
    // personalGainProfit: ['', Validators.required],
    // onlinePaymentInformation: ['', Validators.required],
    declarationContent: ['', Validators.required],
    // permissionGrantStatus: ['', Validators.required],
    // grantedRefundMade: ['', Validators.required],
    // grantedRefundParticulars: ['', Validators.required],
    agree: [false],
    declare: [false]
  });


  ngOnInit() {

    this.route.params.subscribe((params: Params) => this.decryptRegistrationId = params.id);
    this.registrationId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptRegistrationId);
    this.roleName = sessionStorage.getItem('selectedRole-usec');

    if (this.roleName === 'PTR' || this.roleName === 'College Principal') {


      this.seekClarificationForm = this.formBuilder.group({
        comment: ['', Validators.required]
      });

      this.getAllCountry();
      this.getAllCities();
      this.getAllStates();
      this.getPtrDetails();
    } else {
      this.signinService.deleteOauthToken();
    }
  }

  get f() { return this.formGroupId.controls; }

  get re() { return this.seekClarificationForm.controls; }


  findState() {
    let countryId = this.formGroupId.value.countryId;
    this.stateList = this.allstateList.filter(function (item) {
      return item.country.countryId == parseInt(countryId);
    });
  }
  findCity() {
    let stateId = this.formGroupId.value.stateId;
    this.cityList = this.allcityList.filter(function (item) {
      if (item.state !== null && item.state.stateId !== "") {
        return item.state.stateId == parseInt(stateId);
      }
    });
  }
  selecetdDate(data: any) {

    this.formGroupId.controls.endDate.setValue("");
    this.maxDate = moment(data).add(0, 'days').format('YYYY-MM-DD');
  }

  selecetdInviteeDate(data: any) {

    this.inviteemaxDate = moment(data).add(0, 'days').format('YYYY-MM-DD');
  }
  selecetdPermittedDate(data: any) {

    this.formGroupId.controls.permittedEndDate.setValue("");
    this.PermittedMaxDate = moment(data).add(0, 'days').format('YYYY-MM-DD');
  }

  getAllCountry() {
    this.ptrService.countryList().subscribe((result: any) => {
      this.countryList = result;
    }, error => {
      console.log(error);
    });
  }

  getAllCities() {
    this.ptrService.cityList().subscribe((result: any) => {
      this.allcityList = result;
    }, error => {
      console.log(error);
    });
  }

  getAllStates() {
    this.ptrService.stateList().subscribe((result: any) => {
      this.allstateList = result;
    }, error => {
      console.log(error);
    });
  }

  getPtrDetails() {
    this.route.params.subscribe(params => {
      if (this.registrationId != undefined) {
        this.formGroupId.value.registrationId = this.registrationId;
        //For User login Editable mode
        this.spinner.show();
        this.ptrService.userDetailsById(this.registrationId).subscribe((result: any) => {
          this.spinner.hide();
          this.userDetails = result;
          this.formdata(this.userDetails)
        }, error => {
          this.spinner.hide();
          console.log(error);
          this.helper.errorMessage(error);
        });
      }
    });


    this.initializeForm();
    this.addRow('ToAddress', 0);
    let x = this.form.get('itemRows')['controls'];
    for (let j = 0; j < x.length; j++) {
      x[j].controls.inviteename.setValidators(Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(100)]));
      x[j].controls.inviteeemail.setValidators(Validators.compose([Validators.required, Validators.email, Validators.maxLength(255)]));
      x[j].controls.inviteeaddressLine1.setValidators(Validators.compose([Validators.required, Validators.maxLength(255)]));
      x[j].controls.inviteeaddressLine2.setValidators(Validators.compose([Validators.required, Validators.maxLength(255)]));
      x[j].controls.inviteecountryId.setValidators(Validators.compose([Validators.required]));
      x[j].controls.inviteestateId.setValidators(Validators.compose([Validators.required]));
      x[j].controls.inviteecityId.setValidators(Validators.compose([Validators.required]));
      x[j].controls.inviteepinCode.setValidators(Validators.compose([Validators.required, Validators.pattern(/^[^-\s][0-9 ]*$/)]));
      x[j].controls.inviteemobileNumber.setValidators(Validators.compose([Validators.required, Validators.pattern(/^[^-\s][0-9 ]*$/)]));
      x[j].controls.clinicalExperience.setValidators(Validators.compose([Validators.required]));
      x[j].controls.qualification.setValidators(Validators.compose([Validators.required]));
      x[j].controls.inviteecertificateRegistration.setValidators(Validators.compose([Validators.required]));
      x[j].controls.inviteedocumentaryProof.setValidators(Validators.compose([Validators.required]));
      x[j].controls.universityName.setValidators(Validators.compose([Validators.required]));
      x[j].controls.workingPeriodFrom.setValidators(Validators.compose([Validators.required]));
      x[j].controls.workingPeriodTo.setValidators(Validators.compose([Validators.required]));
      x[j].controls.councilName.setValidators(Validators.compose([Validators.required]));
      x[j].controls.validUpto.setValidators(Validators.compose([Validators.required]));
    }
  }

  formdata(result) {
    this.formGroupId = this.formBuilder.group({
      registrationId: result.registrationId,
      name: result.name,
      userEmail: result.userEmail,
      addressLine1: result.addressLine1,
      addressLine2: result.addressLine2,
      countryId: result.countryId,
      stateId: result.stateId,
      cityId: result.cityId,
      pinCode: result.pinCode,
      mobileNumber: result.mobileNumber,
      certificateRegistration: result.certificateRegistration,
      purposeConducting: result.purposeConducting,
      startDate: result.startDate,
      endDate: result.endDate,
      venueProgram: result.venueProgram,
      documentaryProof: result.documentaryProof,
      agree: result.agree,
      declare: result.declare,
      declarationContent: result.declarationContent,
      landlineNumber: result.landlineNumber,
      applicationId: result.applicationId
    });
    this.findState();
    this.findCity();
  }

  onSaveDraft() {
    this.submitted = false;
    this.formGroupId.value.permittedStartDate = this.formGroupId.value.permittedStartDate;
    this.formGroupId.value.permittedEndDate = this.formGroupId.value.permittedEndDate;
    this.formGroupId.value.endDate = this.formGroupId.value.endDate;
    this.formGroupId.value.startDate = this.formGroupId.value.startDate;
    this.ptrService.saveRegistrationDraft(this.formGroupId.value).subscribe((data: any) => {
      if (data.response.respcode == '200') {
        this.uploadfiles();
        setTimeout(() => {
          window.location.reload();
        }, 500);
      } else if (data.response.respcode == '500') {
        this.spinner.hide();
        this.displayErrorMsg('error', data.response.message);
      } else {
        this.spinner.hide();
        this.displayErrorMsg('error', 'Update is Failed!!');
      }
    }, error => {
      this.spinner.hide();
      error.status = error.status == 0 ? 500 : error.status
    });
  }

  onSubmit(status) {
    this.submitted = true;
    if (this.formGroupId.invalid) {
      return;
    }
    const allArray = [];
    this.formGroupId.value.permittedStartDate = this.formGroupId.value.permittedStartDate;
    this.formGroupId.value.permittedEndDate = this.formGroupId.value.permittedEndDate;
    this.formGroupId.value.endDate = this.formGroupId.value.endDate;
    this.formGroupId.value.startDate = this.formGroupId.value.startDate;
    // this.formGroupId.value.applicationStatus = status;
    // this.formGroupId.value.currentOwner = 'PDMSExecutive';
    this.formGroupId.value.roleName = sessionStorage.getItem('selectedRole-usec');
    this.formGroupId.value.declare = this.convertStringToBoolean(this.formGroupId.get('declare').value);
    this.formGroupId.value.agree = this.convertStringToBoolean(this.formGroupId.get('agree').value);

    for (const iterator of this.form.getRawValue().itemRows) {
      const addobj = {
        inviteeName: iterator.inviteename,
        userEmail: iterator.inviteeemail,
        mobileNumber: iterator.inviteemobileNumber,
        addressLine1: iterator.inviteeaddressLine1,
        addressLine2: iterator.inviteeaddressLine2,
        cityId: iterator.inviteecityId,
        stateId: iterator.inviteestateId,
        pinCode: iterator.inviteepinCode,
        countryId: iterator.inviteecountryId,
        qualification: iterator.qualification,
        inviteecertificateRegistration: iterator.inviteecertificateRegistration,
        inviteedocumentaryProof: iterator.inviteedocumentaryProof,
        universityName: iterator.universityName,
        councilName: iterator.councilName,
        workingFrom: iterator.workingPeriodFrom,
        workingTo: iterator.workingPeriodTo,
        validUpto: iterator.validUpto
      }
      allArray.push(addobj);
    }

    this.formGroupId.value.inviteeList = allArray;

    for (let i = 0; i < this.formGroupId.value.inviteeList.length; i++) {
      this.formGroupId.value.inviteeList[i].inviteedocumentaryProof = this.inviteeFileName[i];
    }

    this.ptrService.updateRegistration(this.formGroupId.value).subscribe((data: any) => {
      if (data.response.respcode == '200') {
        this.tostar.success('PTR details updated successfully', 'Success', {
          timeOut: 2000
        });
        this.uploadfiles();
        this.router.navigate(['/main/internal/ptr/dashboard/0']);
      } else if (data.response.respcode == '500') {
        this.spinner.hide();
        this.displayErrorMsg('error', data.response.message);
      } else {
        this.spinner.hide();
        this.displayErrorMsg('error', 'Update is Failed!!');
      }
    }, error => {
      this.spinner.hide();
      error.status = error.status == 0 ? 500 : error.status

    });

  }

  private displayErrorMsg(type: string, msg: string) {
    if (type == 'error') {
      this.toastr.error(msg, 'Error', {
        timeOut: 3000
      });
    }
  }
  uploadfiles() {
    this.ptrService.uploadFile(this.files, this.formGroupId.value.userEmail).subscribe((data: any) => {
      if (data.response.respcode == '200') {

      } else if (data.response.respcode == '500') {

      }
    }, error => {

    });
  }

  files = [];
  onSelectFile(event, filename) {
    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files;
      this.files.push(filesAmount[0]);
      let email = sessionStorage.getItem('email-Id');
      this.formGroupId.controls[filename].setValue("/" + email + "/" + filesAmount[0].name);

    }
  }

  onSelectInviteeFile(event, filename, index) {
    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files;
      this.files.push(filesAmount[0]);
      let email = sessionStorage.getItem('email-Id');

      this.inviteeFileName.push("/" + email + "/" + filesAmount[0].name);


    }
  }
  download(type) {
    let filepath = this.formGroupId.value[type];
    window.open(`${this.serverURL.ptrDocument}` + filepath)
  }
  downloadFile(blobdata, filepath) {
    const downloadLink = document.createElement("a");
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute("href", window.URL.createObjectURL(filepath));
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  private convertStringToBoolean(value) {
    return (value == undefined || value == null || value == "") ? false : true
  }

  initializeForm() {
    this.form = this._form.group({
      itemRows: this._form.array([]),
    });
  }

  itemRows() {
    return this._form.group({
      inviteename: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]],
      inviteeemail: ['', [Validators.required, Validators.email, Validators.maxLength(255)]],
      inviteeaddressLine1: ['', [Validators.required, Validators.maxLength(255)]],
      inviteeaddressLine2: ['', [Validators.required, Validators.maxLength(255)]],
      inviteecountryId: ['', Validators.required],
      inviteestateId: ['', Validators.required],
      inviteecityId: ['', Validators.required],
      inviteepinCode: ['', [Validators.required, Validators.maxLength(10), Validators.pattern("^[0-9]*$")]],
      inviteemobileNumber: ['', [Validators.required, Validators.maxLength(10), Validators.pattern("^[0-9]*$")]],
      clinicalExperience: ['', Validators.required],
      qualification: ['', Validators.required],
      inviteecertificateRegistration: ['', Validators.required],
      inviteedocumentaryProof: ['', Validators.required],
      universityName: ['', Validators.required],
      workingPeriodFrom: ['', Validators.required],
      workingPeriodTo: ['', Validators.required],
      councilName: ['', Validators.required],
      validUpto: ['', Validators.required]
    });
  }

  public addRow(address: any, i) {
    const control = <FormArray>this.form.controls['itemRows'];
    // control.push(this.itemRows());
    this.toAddressArr = this.form.get('itemRows') as FormArray;
    this.toAddressArr.push(this.itemRows());
    let x = this.form.get('itemRows')['controls'];
    x[i].controls.inviteename.setValidators(Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(100)]));
    x[i].controls.inviteeemail.setValidators(Validators.compose([Validators.required, Validators.email, Validators.maxLength(255)]));
    x[i].controls.inviteeaddressLine1.setValidators(Validators.compose([Validators.required, Validators.maxLength(255)]));
    x[i].controls.inviteeaddressLine2.setValidators(Validators.compose([Validators.required, Validators.maxLength(255)]));
    x[i].controls.inviteecountryId.setValidators(Validators.compose([Validators.required]));
    x[i].controls.inviteestateId.setValidators(Validators.compose([Validators.required]));
    x[i].controls.inviteecityId.setValidators(Validators.compose([Validators.required]));
    x[i].controls.inviteepinCode.setValidators(Validators.compose([Validators.required, Validators.pattern(/^[^-\s][0-9 ]*$/)]));
    x[i].controls.inviteemobileNumber.setValidators(Validators.compose([Validators.required, Validators.pattern(/^[^-\s][0-9 ]*$/)]));
    x[i].controls.qualification.setValidators(Validators.compose([Validators.required]));
    x[i].controls.inviteecertificateRegistration.setValidators(Validators.compose([Validators.required]));
    x[i].controls.inviteedocumentaryProof.setValidators(Validators.compose([Validators.required]));
    x[i].controls.universityName.setValidators(Validators.compose([Validators.required]));
    x[i].controls.workingPeriodFrom.setValidators(Validators.compose([Validators.required]));
    x[i].controls.workingPeriodTo.setValidators(Validators.compose([Validators.required]));
    x[i].controls.councilName.setValidators(Validators.compose([Validators.required]));
    x[i].controls.validUpto.setValidators(Validators.compose([Validators.required]));
    // this.getAllBulkCategory();
  }

  removeRows(j) {

    const control = <FormArray>this.form.controls['itemRows'];
    control.removeAt(j);
  }

  viewDocuments(filePath: any, fileName: any) {
    this.usrMgtService.getRandomKeyGeneratorForViewDocument().subscribe((data: any) => {
      const randomkeyKey = this.ced.decryptAesformString(data.randamKey, this.serverURL.secretKey);
      this.viewDocumentsAfterEncryptedfilePath(this.ced.encryptAesToString(filePath, randomkeyKey).toString(), fileName);
    }, error => {
      console.log(error);
    });
  }

  viewDocumentsAfterEncryptedfilePath(filePath: any, fileName: any) {
    this.spinner.show();
    this.usrMgtService.ViewDocument(filePath).pipe().subscribe((result: any) => {
      this.spinner.hide();
      var blob = result;
      var fileURL = URL.createObjectURL(blob);
      if (fileName.split('.').pop().toLowerCase() === 'pdf') {
        window.open(fileURL);
      } else {
        var a = document.createElement("a");
        a.href = fileURL;
        a.target = '_blank';
        a.download = fileName;
        a.click();
      }
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }

  previewPdf() {
    this.ptrService.getAcceptanceLetterPdf(this.userDetails.registrationId).pipe(takeUntil(this.subscribe)).subscribe((res: any) => {

      const fileURL = URL.createObjectURL(res);
      window.open(fileURL, '_blank');
    }, error => {
      console.log(error);
    })
  }


  back() {
    this.router.navigate(['/main/internal/ptr/dashboard/0']);
    sessionStorage.setItem("back", "back");
  }

  // resetting forms method
  reset() {
    this.seekClarificationForm.reset();
  }


  ptrApplicationReSubmit() {
    this.submitted = true;
    if (this.seekClarificationForm.valid) {
      const obj = {
        whoAssignedUserId: sessionStorage.getItem('userId-usec'),
        comments: this.seekClarificationForm.value.comment ? this.seekClarificationForm.value.comment : "",
        registrationId: this.registrationId,
        roleName: sessionStorage.getItem('selectedRole-usec'),
        //Application Resubmitted
        statusCode: 'AR'
      };
      this.ptrService.ptrApplicationReSubmit(obj).pipe(takeUntil(this.subscribe)).subscribe((data: any) => {
        this.submitted = false;
        this.seekClarificationCandidateCloseBtn.nativeElement.click();
        this.tostar.success('Application Resubmitted Successfully', 'Success', {
          timeOut: 5000
        });
        this.back();
      }, error => {
        console.log(error);
      });
    }
  }

}
